import { Outlet } from 'react-router-dom'

/** Контент маршрутов `/admin` (сайдбар — в {@link AppLayout}). */
export function AdminLayout() {
  return <Outlet />
}
